import React from 'react';
import { CostsSubTitle, CostsWrapper, LargeRowWrapper, LowPowerBox, RowWrapper } from './Costs.styled';
import KPICard from '../KPICard/KPICard';
import { StyledTextInputAnalysis, SubPageTitle, KPIRow, SubmitButton, StyledForm, AddButton } from '../../pages/AnalysisPage/AnalysisPage.styled';
import { useSelector, useDispatch } from 'react-redux';
import { updateRecurringCosts, updateOneTimeCosts, updateElectricalPanelFlag } from '../../features/outputs/outputs';
import { populateInputs, resetEnableReset } from '../../features/inputs/inputs';

function Costs () {
   const recurringCosts = useSelector((state) => state.inputs.value.costMonthlyArr);
   const oneTimeCosts = useSelector((state) => state.inputs.value.costOneTimeArr);
   const source = useSelector((state) => state.outputs.value.cost.dataSource);
   const output = useSelector((state) => state.outputs.value);
   const inputs = useSelector((state) => state.inputs.value);
   const dispatch = useDispatch();
   const baseOneTimeCosts = ["Hardware Cost", "Labor and Other Costs", "Panel Upgrade Costs"];
   const baseRecurringCosts = ["Monthly Networking Cost", "Insurance Cost"];
   const numParkingSpaces = inputs.parkingSpacesToElectrify + inputs.assignedParkingSpacesToElectrify;

   const handleClose = () => dispatch(updateElectricalPanelFlag(false));

   const handleAdd = (event, costList) => {
      event.preventDefault();
      event.target[0].value = event.target[0].value.replace('$', '');
      event.target[0].value = event.target[0].value.replace(',', '');
      const costObj = 
      {
         isTotal: false,
         number: Number(event.target[0].value),
         label: event.target[1].value
      }
      if (costList === recurringCosts) {
         dispatch(updateRecurringCosts([costObj, ...recurringCosts]));
         dispatch(populateInputs({...inputs, costMonthlyArr: [...inputs.costMonthlyArr, {amount: costObj.number, title: costObj.label}]}));
         dispatch(resetEnableReset(true));
         document.getElementById("monthlyCostsForm").reset();
      } else {
         dispatch(updateOneTimeCosts([costObj, ...oneTimeCosts]));
         dispatch(populateInputs({...inputs, costOneTimeArr: [...inputs.costOneTimeArr, {amount: costObj.number, title: costObj.label}]}));
         dispatch(resetEnableReset(true));
         document.getElementById("oneTimeCostsForm").reset();
      }
   }

   const determineSource = () => {
      if (source === "BLS Adjusted Estimate") {
         return "Bureau of Labor Statistics Adjusted Estimate";
      } else if (source === "All Other States - BLS Adjusted") {
         return "Bureau of Labor Statistics Adjusted Estimate";
      } else if (source.includes("Mixture")) {
         return `Mix of National Data and ${inputs.state} Data`;
      } else {
         return `${inputs.state} State Estimate`;
      }
   }

   const handleRemove = (event, costList, costToRemove) => {
      const costObj = 
      {
         isTotal: false,
         number: Number(costToRemove.amount),
         label: costToRemove.title
      }
      if (costList === recurringCosts) {
         dispatch(updateRecurringCosts(recurringCosts.filter((cost) => cost !== costObj)));
         dispatch(populateInputs({...inputs, costMonthlyArr: inputs.costMonthlyArr.filter((cost) => cost !== costToRemove)}));
         dispatch(resetEnableReset(true));
      } else {
         dispatch(updateOneTimeCosts(oneTimeCosts.filter((cost) => cost !== costObj)));
         dispatch(populateInputs({...inputs, costOneTimeArr: inputs.costOneTimeArr.filter((cost) => cost !== costToRemove)}));
         dispatch(resetEnableReset(true));
      }
   }

   return (
   <>
      <CostsWrapper>
      <div>This tab shows estimated costs without considering rebates or incentives. This tool assumes there are not utility upgrade costs required for this project, such as line or panel upgrades. If you have an estimate for those costs, please add them below. <b>To retrieve initial costs, click "Reset" above.</b></div>
      <LargeRowWrapper>
      <div>
         <SubPageTitle>One-Time Costs</SubPageTitle>
            <div>Data Source: {determineSource()}. See "More Info" for details.</div>
            <div>These costs are for electrifying <b>{numParkingSpaces} parking space{numParkingSpaces !== 1 ? 's' : ''}.</b> This assumes <b>{Math.ceil(numParkingSpaces/2)} dual port charger{Math.ceil(numParkingSpaces/2) !== 1 ? 's' : ''}.</b></div>
            <KPIRow width="80%">
            <KPICard key={oneTimeCosts.length} isTotal={true} number={`$${oneTimeCosts.map((cost) => cost.amount).reduce((accumulator, currentValue) => accumulator + currentValue, 0).toLocaleString('en', { maximumFractionDigits: 0, useGrouping: true})}`} label={"Total One-Time Costs"} />
               {oneTimeCosts.map((cost, index) => (
                  <KPICard key={index} isTotal={false} allowRemove={true} number={`$${cost.amount.toLocaleString(undefined, {maximumFractionDigits: 0})}`} label={cost.title} handleRemove= {(e) => handleRemove(e, oneTimeCosts, cost)} />
               ))}
            </KPIRow>
            <CostsSubTitle>Additional One-Time Costs</CostsSubTitle>
            Add any additional one-time costs here. Speak with local electrical contractors for an accurate estimate of installation and panel upgrade costs.
            {baseOneTimeCosts.map((cost) => oneTimeCosts.map((innerCost) => innerCost.title).includes(cost) ? null :
            <StyledForm 
               width='50%' 
               onSubmit={(e) => handleAdd(e, oneTimeCosts)}
               id="oneTimeCostsForm"
            >
               <StyledTextInputAnalysis
                     id="oneTimeCosts"
                     placeholder="$"
                     width='10%'
               />
               <StyledTextInputAnalysis
                     id="oneTimeCostDescription"
                     defaultValue={cost}
                     readOnly={true}
                     width='50%'
               />
               <AddButton type="submit">Add</AddButton>
               </StyledForm>
            )}
            <StyledForm 
               width='50%' 
               onSubmit={(e) => handleAdd(e, oneTimeCosts)}
               id="oneTimeCostsForm"
            >
               <StyledTextInputAnalysis
                     id="oneTimeCosts"
                     placeholder="$"
                     width='10%'
               />
               <StyledTextInputAnalysis
                     id="oneTimeCostDescription"
                     placeholder="Description"
                     aria-label='Description'
                     width='50%'
               />
               <AddButton type="submit">Add</AddButton>
               </StyledForm>
            <RowWrapper>
         </RowWrapper>
         </div>
         {(inputs.parkingConfig === "Assigned or Deeded" ||
            (inputs.parkingSpacesToElectrify + inputs.assignedParkingSpacesToElectrify == inputs.parkingSpaces + inputs.assignedParkingSpaces) ||
            (inputs.parkingConfig === "Mixed" && inputs.assignedParkingSpacesToElectrify > 0)) ?
         <LowPowerBox>
            <CostsSubTitle>Low-Power Considerations</CostsSubTitle>
            <p>The one-time costs shown are for Level 2 (L2) chargers. However, you may want to consider low power options like Level 1 (L1) or low-power outlets 
               or load-managed L2 chargers, 
               which will deliver less energy but can be cheaper to install. 
               {inputs.parkingConfig === "Mixed" && !(inputs.parkingSpacesToElectrify + inputs.assignedParkingSpacesToElectrify == inputs.parkingSpaces + inputs.assignedParkingSpaces) ?
               <p>We recommend installing L1 and low power L2 outlets and chargers (anything less than 5kWh) in assigned/deeded parking spaces. Installing <b>{inputs.assignedParkingSpacesToElectrify}</b> L1 chargers in 
               assigned/deeded parking spaces would be expected to cost <b>${(output.cost.lowPowerMedian*inputs.assignedParkingSpacesToElectrify).toLocaleString(undefined, { maximumFractionDigits: 0})}</b>. </p>
               : <p>
               Installing <b>{numParkingSpaces}</b> L1 chargers 
               costs <b>${(output.cost.lowPowerMedian*numParkingSpaces).toLocaleString(undefined, { maximumFractionDigits: 0})}</b> on average. 
               </p>}
               Monthly costs for L1 chargers will likely be lower as well.
               Please note that L1 chargers typically do not qualify for the incentives shown in this application. 
               Given limited installation data, this tool is currently built to analyze L2 installation costs, incentives, and ROI estimates.</p>
         </LowPowerBox> : null }
         </LargeRowWrapper>
         <SubPageTitle>Recurring Costs</SubPageTitle>
         <KPIRow width='50%'>
         <KPICard key={recurringCosts.length} isTotal={true} number={`$${recurringCosts.map((cost) => cost.amount*12).reduce((accumulator, currentValue) => accumulator + currentValue, 0).toLocaleString(undefined, { maximumFractionDigits: 0})}`} label={"Total Annual Costs"} />
            {recurringCosts.map((cost, index) => (
               <KPICard key={index} isTotal={false} allowRemove={true} number={`$${cost.amount.toLocaleString(undefined, { maximumFractionDigits: 0})}`} label={cost.title} handleRemove= {(e) => handleRemove(e, recurringCosts, cost)} />
            ))}
         </KPIRow>
         <CostsSubTitle>Additional Recurring Costs</CostsSubTitle>
         Add any additional monthly costs here. These will likely include networking and insurance costs.
         {baseRecurringCosts.map((cost) => recurringCosts.map((innerCost) => innerCost.title).includes(cost) ? null :
         <StyledForm 
            width='50%' 
            onSubmit={(e) => handleAdd(e, recurringCosts)}
            id="monthlyCostsForm"
         >
            <StyledTextInputAnalysis
                  id="monthlyCosts"
                  placeholder="$"
                  width='10%'
            />
            <StyledTextInputAnalysis
                  id="monthlyCostDescription"
                  defaultValue={cost}
                  readOnly={true}
                  width='50%'
            />
            <AddButton type="submit">Add</AddButton>
            </StyledForm>
         )}
            <StyledForm width='50%' 
                        onSubmit={(e) => handleAdd(e, recurringCosts)}
                        id="monthlyCostsForm"
            >
               <StyledTextInputAnalysis
                     id="monthlyCosts"
                     placeholder="$"
                     width={'10%'}
               />
               <StyledTextInputAnalysis
                     id="monthlyCostDescription"
                     placeholder="Description"
                     aria-label='Description'
                     width={'50%'}
               />
               <AddButton type="submit">Add</AddButton>
            </StyledForm>
      </CostsWrapper>
   </>

   )};

Costs.propTypes = {};

Costs.defaultProps = {};

export default Costs;
